import React from 'react';
import { useTranslation } from 'react-i18next';

export function WidgetSpan ({ type, text }) {
    const { t } = useTranslation();
    const formattedText = /\..*\./.test(text) ? t(text) : text;
    return (<span>{formattedText}</span>);
}

// Set display names for debugging.
if (process.env.NODE_ENV !== 'production') {
    WidgetSpan.displayName = 'WidgetSpan';
}
